import {useTranslation} from "react-i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useRef, useState} from "react";
import {Button, Form, Input} from "antd";
import "../../../core/style/grid-filter.css";
import RequestTypeSelectBox from "../../request-type/RequestTypeSelectBox";
import ModalitySelectBox from "../../modality/ModalitySelectBox";

export default function ReportTemplateFilter()
{
    const {t} = useTranslation();
    const formRef = useRef();
    const [modalityId, setModalityId] = useState();
    const {onFilterPageSort} = useDataGrid();

    const filter = (form) => {
        onFilterPageSort({
            filter: {
                ...form,
                modalityIdList: form.modalityId && [form.modalityId],
                requestTypeIdList: form.requestTypeIdList && [form.requestTypeIdList]
            }
        })
    }

    const reset = () => {
        formRef.current.resetFields();
        formRef.current.setFieldsValue({
            requestTypeIdList: null,
            modalityId: null
        })
        setModalityId(undefined)
        onFilterPageSort({
            filter: {}
        })
    }

    const onChangeModality = (modalityId) => {
        setModalityId(modalityId);
        formRef.current.setFieldsValue({
            requestTypeIdList: null
        })
    }

    return (
        <>
            <Form
                layout={'vertical'}
                ref={formRef}
                onFinish={filter}
                // Grid üstündeki yatay filtre kartında durur (bkz. GridFilterCard).
                className={'grid-filter-form grid-filter-inline'}
            >
                <Form.Item
                    label={t('Search')}
                    name={'searchText'}
                    className={'grid-filter-wide'}
                >
                    <Input placeholder={t('Name, request type, modality, SUT code or owner')} allowClear />
                </Form.Item>

                <Form.Item
                    label={t('Modality')}
                    name={'modalityId'}
                >
                    <ModalitySelectBox
                        onChange={onChangeModality}
                        mode={'single'}
                    />
                </Form.Item>

                <Form.Item
                    label={t('Request Type')}
                    name={'requestTypeIdList'}
                >
                    <RequestTypeSelectBox
                        modalityId={modalityId}
                        style={{width: '100%'}}
                    />
                </Form.Item>

                <Form.Item className={'grid-filter-actions'}>
                    <Button type={'primary'} htmlType="submit" >{t('Search')}</Button>
                    <Button onClick={reset}>{t('Reset')}</Button>
                </Form.Item>
            </Form>
        </>
    )
}
